import type { State } from './state';
import type { Language, UserProfile } from '@/types';
import { i18n } from '@/plugins/i18n';

export enum MutationType {
    SetUser = 'SET_USER',
    SetLanguages = 'SET_LANGUAGES',
}

export type Mutations = {
    [MutationType.SetUser](state: State, user: UserProfile | null): void;
    [MutationType.SetLanguages](state: State, languages: Language[]): void;
};

function applyLocale(state: State) {
    if (!state.user?.languageId || !state.languages.length) return;
    const lang = state.languages.find((l) => l.id === state.user!.languageId);
    if (lang) {
        i18n.global.locale.value = lang.code;
        document.documentElement.setAttribute('lang', lang.code);
    }
}

export const mutations: Mutations = {
    [MutationType.SetUser](state, user) {
        state.user = user;
        applyLocale(state);
    },
    [MutationType.SetLanguages](state, languages) {
        state.languages = languages;
        applyLocale(state);
    },
};
